import React, { FC, useLayoutEffect, useState } from 'react';
import { renderToString } from 'react-dom/server';

import { Text } from '@chakra-ui/layout';
import { Select } from '@chakra-ui/select';
import { Spinner } from '@chakra-ui/spinner';
import { MdArrowDropDown } from 'react-icons/md';
import { FormControl, FormLabel } from '@chakra-ui/form-control';

import { useField } from 'formik';

import { FormikSelectInputProps } from './FormikSelectInput.props';

const FormikSelectInput: FC<FormikSelectInputProps> = (props) => {
  const {
    name,
    label,
    children,
    isRequired,
    isLoading = false,
    placeholder = '',
    defaultValue = '',
    labelProps = {},
    containerProps = {},
    leftElement,
    onSuccess = (value: string) => null,
    onChange = (value: string) => null,
    isFromInventoryCount,
    selectedInventoryItem,
    isReadOnly,
    ...otherProps
  } = props;

  const [field, meta, helpers] = useField(name);
  const [isAutoSelected, setIsAutoSelected] = useState<boolean>(false);

  useLayoutEffect(() => {
    if (isFromInventoryCount) {
      setIsAutoSelected(true);
      helpers.setValue('1');
    }

    if (selectedInventoryItem) {
      setIsAutoSelected(true);
      const seletedItemId: any = selectedInventoryItem?._id;
      helpers.setValue(seletedItemId);
      onChange(seletedItemId);
    }
    if (!leftElement) {
      return;
    }

    const selectElement = document.getElementById(name);
    const parentElement = selectElement?.parentElement;
    const leftElementContainer = document.createElement('div');

    if (parentElement) {
      const htmlString = renderToString(leftElement);

      leftElementContainer.innerHTML = htmlString;
      leftElementContainer.style.position = 'absolute';
      leftElementContainer.style.left = '0.6rem';
      leftElementContainer.style.top = '30%';
      leftElementContainer.style.pointerEvents = 'none';
      leftElementContainer.style.display = 'inline-flex';

      selectElement.style.paddingLeft = '30px';

      parentElement.insertBefore(leftElementContainer, selectElement);
    }
  }, []);

  return (
    <FormControl mt={3} {...containerProps} isRequired={isRequired}>
      <FormLabel
        htmlFor={name}
        fontSize="12px"
        color="#afafaf"
        fontWeight="bold"
        textTransform="capitalize"
        {...labelProps}>
        {label}
      </FormLabel>
      <Select
        id={name}
        backgroundColor={isAutoSelected || isReadOnly ? '#C2C2C2' : 'FFFFFF'}
        isDisabled={isLoading || isAutoSelected || isReadOnly}
        variant="outline"
        placeholder={placeholder}
        onBlur={() => helpers.setTouched(true)}
        onChange={async (e) => {
          const selectedValue = e.target.value;
          helpers.setValue(selectedValue);
          onChange(selectedValue);
          await onSuccess(selectedValue);
        }}
        value={!field.value ? defaultValue : field.value}
        minW="200px"
        isInvalid={!!meta.touched && !!meta.error}
        icon={<MdArrowDropDown />}
        {...otherProps}>
        {children}
      </Select>
      {isLoading && (
        <Spinner size="sm" position="absolute" right={3} bottom={3} bg="#fff" />
      )}
      {meta.error && meta.touched && (
        <Text color="red.500" fontSize="sm">
          {meta.error}
        </Text>
      )}
    </FormControl>
  );
};

export default FormikSelectInput;
